const ALERT_DURATION_DEFAULT = 5000;
const ALERT_DURATION_ERROR = 10000;

export function initializeAlert(alert, time) {
    alert.querySelector('.btn-close').addEventListener('click', function () {
        alert.remove();
    });
    setTimeout(() => {
        alert.classList.add('hide');
        alert.addEventListener('transitionend', (event) => {
            alert.remove();
        });
    }, time);
}

document.addEventListener('bundleLoaded', async function () {
    if (localStorage.getItem('alert')) {
        const parsed_alert = JSON.parse(localStorage.getItem('alert'));
        addAlert(parsed_alert[0], parsed_alert[1]);
        localStorage.removeItem('alert');
    }
    let counter = 0;
    document.querySelectorAll('.alerts .alert').forEach((alert) => {
        setTimeout(() => {
            alert.classList.add('show');
        }, 100 * counter);

        counter++;

        const isError = alert.classList.contains('alert-error');
        const baseTime = isError
            ? ALERT_DURATION_ERROR
            : ALERT_DURATION_DEFAULT;

        initializeAlert(alert, baseTime + counter * 1000);
    });
});

export function addAlert(tag, message) {
    let tagLabel = '';
    switch (tag) {
        case 'success':
            tagLabel = gettext('SUKCES!');
            break;
        case 'error':
            tagLabel = gettext('BŁĄD!');
            break;
        case 'warning':
            tagLabel = gettext('UWAGA!');
            break;
        case 'info':
            tagLabel = gettext('INFORMACJA!');
            break;
        default:
            break;
    }
    const alertHTML = `
        <div class="alert alert-${tag}">
            <span class="tag">${tagLabel}</span>
            <span class="text">${message}</span>
            <button type="button" class="btn-close" aria-label=${gettext('Zamknij powiadomienie')}>
                <span class="icon-close-bold"></span>
            </button>
        </div>
    `;
    document
        .querySelector('.alerts')
        .insertAdjacentHTML('beforeend', alertHTML);
    const newAlert = document.querySelector('.alerts .alert:last-child');
    requestAnimationFrame(() => {
        newAlert.classList.add('show');
    });

    const duration =
        tag === 'error' ? ALERT_DURATION_ERROR : ALERT_DURATION_DEFAULT;
    initializeAlert(newAlert, duration);
}

export function genericErrorAlert() {
    addAlert(
        'error',
        gettext(
            'Coś poszło nie tak! Spróbuj ponownie lub skontaktuj się z administratorem.',
        ),
    );
}

export function addLocalStorageAlert(tag, message) {
    localStorage.setItem('alert', JSON.stringify([tag, message]));
}

export function initializeRedirectAlertHandler() {
    const postRedirectAlert = sessionStorage.getItem('postRedirectAlert');
    if (postRedirectAlert) {
        try {
            const alertData = JSON.parse(postRedirectAlert);
            addAlert(alertData.type, alertData.message);
        } catch (e) {
            console.error('Failed to parse or display post-redirect alert:', e);
        } finally {
            sessionStorage.removeItem('postRedirectAlert');
        }
    }
}

export function setRedirectAlert(type, message) {
    if (!type || !message) {
        console.error('setRedirectAlert requires both a type and a message.');
        return;
    }
    const alertInfo = { type, message };
    sessionStorage.setItem('postRedirectAlert', JSON.stringify(alertInfo));
}

export default {
    addAlert,
    initializeAlert,
    addLocalStorageAlert,
    setRedirectAlert,
    initializeRedirectAlertHandler,
};
